import React from 'react';
import { motion } from 'framer-motion';

const Header = () => {
  return (
    <motion.header
      className="bg-[#0B0B0B] w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25, ease: [0.32, 0.72, 0, 1] }}
    >
      {/* Header is now minimal — identity lives in nav, personality lives in hero */}
    </motion.header>
  );
};

export default Header;
